<template>
    <main class="app-container">
        <div>
            <section class="settings">
                <h1>{{ $t('profile_settings.settings') }}</h1>
                <div class="settings__box">
                    <div class="settings__box-left">
                        <change-password></change-password>
                    </div>
                </div>
                <div class="settings__box">
                    <div class="settings__box-full">
                        <privacy></privacy>
                    </div>
                </div>

                <div class="settings__box">
                    <div class="settings__box-full">
                        <p class="settings__box-heading">{{ $t('profile_settings.delete_account.delete_account_title') }}</p>
                        <div class="settings__privacy-wrapper">
                            <button class="button-outline" type="submit" data-a11y-dialog-show="delete-account-dialog">{{ $t('profile_settings.delete_account.remove_account_button') }}</button>
                        </div>
                    </div>
                </div>

                <delete-account />
            </section>
        </div>
    </main>
</template>

<script>
import UserLayout from "@/layouts/UserLayout";
import Menu from "@/components/Menu";
import ChangePassword from "@/components/settings/ChangePassword";
import Privacy from "@/components/settings/Privacy";
import DeleteAccount from "@/components/settings/deleteAccount.vue";
export default {
    name: "ProfileSettingsView",
    components: {DeleteAccount, Privacy, ChangePassword, Menu, UserLayout},
}
</script>

<style scoped lang="scss">

::v-deep(.settings) {
    h1 {
        font-size: 2.25rem;
        line-height: 22px;
        margin-bottom: 36px;
        font-weight: 600;
    }
    .settings__box {
        background-color: #fff;
        border: 1px solid #f4f3f3;
        border-radius: 10px;
        padding: 25px 22px 35px 22px;
        // max-width: 1200px;
        width: 100%;
        display: flex;
        align-items: stretch;
        justify-content: space-between;
        flex-wrap: wrap;
        @media screen and (max-width: 767px) {
            flex-direction: column;
        }
        &:not(:last-of-type) {
            margin-bottom: 40px;
        }
        &-left {
            width: 50%;
            max-width: 450px;

            @media screen and (max-width: 850px) {
                width: 100%;
            }
            &-bottom {
                margin: 40px 0 0 0;
            }
        }
        &-full {
            width: 100%;
            max-width: 900px;
        }
        &-heading {
            margin-bottom: 28px;
            font-size: 2.75rem;
            line-height: 26px;
            font-weight: 600;
        }
    }
    .settings__privacy {
        border-top: 1px solid #E4E6E4;
        font-weight: 500;
        font-size: 1.875rem;
        line-height: 18px;
        color: #8C8F94;
        padding: 15px 0 20px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;

        label {
            color: #8C8F94;
            cursor: pointer;
        }
        &-bottom {
            margin: 40px 0 0 0;
        }
    }
}

</style>
